<div *ngIf="!isOpenModal" [formGroup]="mdl_Map" class="map-container">

    <!-- "TEXTAREA" انتخاب حالت دریافت آدرس -->

    <ng-container *ngIf="isTextArea;else isInput">

        <textarea autocomplete="off" class="form-control" (input)="onInput()" formControlName="strText"
            [ngStyle]="getStylesObject()" [placeholder]="str_Placeholder">

        </textarea>

    </ng-container>

    <!-- "INPUT" انتخاب حالت دریافت آدرس -->

    <ng-template #isInput>

        <input autocomplete="off" class="form-control" (input)="onInput()" formControlName="strText"
            [ngStyle]="getStylesObject()" [placeholder]="str_Placeholder" />

    </ng-template>

    <!-- انتخاب حالت نمایش دکمه نقشه -->

    <ng-container *ngIf="isLocationBtn">

        <button class="btn btn-warning rounded" (click)="openMap()">

            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

        </button>

    </ng-container>

</div>

<!-- نقشه -->

<div class="modal fade" id="map_Modal">

    <div class="modal-dialog modal-fullscreen">

        <div class="modal-content" style="direction: rtl;">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel"> {{ isView ? 'موقعیت' : 'انتخاب آدرس' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="submitAddress()"></button>

            </div>

            <div [formGroup]="mdl_Map" class="modal-body">

                <div class="w-100 pb-2">

                    <input class="form-control" 
                        
                        formControlName="strText_Toolbar"

                        [placeholder]="isView ? '' : 'آدرس خود را جستجو کنید...' " 

                        (keyup.enter)="getLatLong()">

                </div>

                <div id="map_Container"> </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <ng-container *ngIf="!isView">

                    <button [disabled]="mdl_Map.get('latitude')?.value != '' ? false : true " class="btn btn-success"
                        (click)="submitAddress()">

                        &nbsp; &nbsp; تایید آدرس &nbsp; &nbsp;

                    </button>

                </ng-container>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal" (click)="submitAddress()">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>